import { DispatchesCanceled } from '../../../../../core';

const iconsOfActionsList = [
  {
    icon: 'cancel',
    tooltip: 'Anular despachos',
    hasVisibleCondition: (element: DispatchesCanceled[]): boolean => true
  }
];

export const dispatchCanceled = {
  searchText: 'Buscar despachos cancelados',
  checkbox: true,
  filter: false,
  filterDefault: '',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (row: DispatchesCanceled) => !row.cancellable,
  paginator: true,
  //paginatorAllData: true,
  columns: [
    {
      title: 'Nota de venta',
      name: 'saleNoteNumber',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: DispatchesCanceled) => element.saleNoteNumber
    },
    {
      title: 'N° Despacho',
      name: 'dispatchNumber',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: DispatchesCanceled) => element.dispatchNumber
    },
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: DispatchesCanceled) => element.skuCode
    },
    {
      title: 'Cant. cancelada',
      name: 'cancelledQuantity',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'center w130',
      value: (element: DispatchesCanceled) => element.cancelledQuantity
    },
    {
      title: 'Sucursal actual',
      name: 'currentEntity',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'center w130',
      value: (element: DispatchesCanceled) => element.currentEntity
    },
    {
      title: 'Entidad origen',
      name: 'entityOrigin',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'center w130',
      value: (element: DispatchesCanceled) => {
        return `${element.entityOriginType} - ${element.entityOrigin}`;
      }
    },
    {
      title: 'Documento',
      name: 'identityDocument',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: DispatchesCanceled) => {
        return `${element.identityDocument}`;
      }
    },
    {
      title: 'Cliente',
      name: 'customer',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: DispatchesCanceled) => element.customer
    }
  ]
};
export const dispatchesCanceledState = {
  iconsOfActions: [],
  columns: [
    {
      title: 'Nota de venta',
      name: 'saleNoteNumber',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: DispatchesCanceled) => element.saleNoteNumber
    },
    {
      title: 'N° Despacho',
      name: 'dispatchNumber',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: DispatchesCanceled) => element.dispatchNumber
    },
    {
      title: 'SKU - Descripción',
      name: 'skuCode',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: DispatchesCanceled) => {
        return `${element.skuCode} - ${element.description}`;
      }
    },
    {
      title: 'Cliente',
      name: 'customer',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'left',
      value: (element: DispatchesCanceled) => {
        return `${element.identityDocument} - ${element.customer}`;
      }
    }
  ]
};
